import {ProposalUser} from '../proposal/proposalUser';
import {ObjectUtil} from '../../util/object-util';
import {OfferType} from '../../enum/offer-type';
import {ExternalInsurer} from './external-insurer';
import {BinaryData} from '../proposal/binary-data';

export class Offer {
  creationDate: Date = null;
  offerId: string = null;
  proposalId: string = null;
  insurerId: string = null;
  creator: ProposalUser = null;
  externalInsurer: ExternalInsurer = null;
  premium: number = null;
  premiumInPercent: number = null;
  premiumPerThousand: number = null;
  premiumReferenceSize: string = null;
  expectedTotalPremium: number = null;
  advancePremium: number = null;
  minimumPremium: number = null;
  currency: string = null;
  standardTermsAndConditions: string[] = [];
  individualTermsAndConditions: string = null;
  standardClauses: string[] = [];
  individualClauses: string = null;
  attachedFiles: BinaryData[] = [];
  bookmarked: boolean = null;
  status: string = null;
  amountCovered: number = null;
  role: string = null;
  isLeading: boolean = null;

  offerType: OfferType = OfferType.OFFER;
  rejectionText: string = null;

  deductibleAbsoluteAmount: number = null;
  deductibleCurrency: string = null;
  typeOfDeductible: string = null;
  deletionTime: Date = null;
  otherInformation: string = null;
  offerDescription: string = null;
  referenceValue: string = null;

  lastTimeEdited: Date = null;

  constructor(object?: Object) {
    ObjectUtil.assign(this, object, ['creationDate', 'deletionTime']);
    if (this.deletionTime != null) {
      this.deletionTime.setDate(this.deletionTime.getDate() + 1);
    }

    if (object != null) {
      if (Object.keys(object).includes('creator')) {
        this.creator = new ProposalUser(object['creator']);
      }
    }
  }
}
